import {
  captureException as sentryCaptureException,
  setSentryUser as sentrySetUser,
  captureUnderscoreErrorException as sentryCaptureUnderscoreErrorException,
  captureReactException as sentryCaptureReactException,
  captureRequestError as sentryCaptureRequestError,
} from "@stadium/services/sentry-nextjs";

import {
  captureException as datadogBrowserCaptureException,
  setDatadogUser,
  captureReactException as datadogCaptureReactException,
} from "@stadium/services/datadog-nextjs";

import { getErrorMonitoringProvider } from "./provider";

export {
  getErrorMonitoringProvider,
  isErrorMonitoringEnabled,
  isSentryProvider,
  isDatadogProvider,
} from "./provider";

const datadogServerCaptureException = (...args) => {
  const serverCapture = globalThis.__STADIUM_DATADOG_SERVER_CAPTURE__;
  if (typeof serverCapture === "function") {
    return serverCapture(...args);
  }
  return datadogBrowserCaptureException(...args);
};

const getImpl = () => {
  const provider = getErrorMonitoringProvider();
  if (provider === "sentry") {
    return {
      captureException: sentryCaptureException,
      setUser: sentrySetUser,
      captureUnderscoreErrorException: sentryCaptureUnderscoreErrorException,
      captureReactException: sentryCaptureReactException,
      captureRequestError: sentryCaptureRequestError,
    };
  }
  if (provider === "datadog") {
    const serverRequestError = globalThis.__STADIUM_DATADOG_CAPTURE_REQUEST_ERROR__;
    return {
      captureException: datadogServerCaptureException,
      setUser: setDatadogUser,
      captureUnderscoreErrorException: async (...args) => {
        const serverUnderscore = globalThis.__STADIUM_DATADOG_CAPTURE_UNDERSCORE_ERROR__;
        if (typeof serverUnderscore === "function") {
          return serverUnderscore(...args);
        }
        return datadogBrowserCaptureException(...args);
      },
      captureReactException: datadogCaptureReactException,
      captureRequestError: async (...args) =>
        typeof serverRequestError === "function"
          ? serverRequestError(...args)
          : datadogServerCaptureException(...args),
    };
  }
  const noop = () => null;
  const noopAsync = async () => null;
  return {
    captureException: noop,
    setUser: noop,
    captureUnderscoreErrorException: noopAsync,
    captureReactException: noop,
    captureRequestError: noopAsync,
  };
};

export const captureException = (...args) => getImpl().captureException(...args);

export const setUser = (...args) => getImpl().setUser(...args);

/** @deprecated Use setUser */
export const setSentryUser = setUser;

export const captureUnderscoreErrorException = (...args) =>
  getImpl().captureUnderscoreErrorException(...args);

export const captureReactException = (...args) => getImpl().captureReactException(...args);

export const captureRequestError = (...args) => getImpl().captureRequestError(...args);

export { reportAppError } from "@stadium/services/error-reporting/report-app-error";
export { AppRouterTracker } from "@stadium/services/error-reporting/app-router-tracker";
